import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';
import {
  fetchHighlightsDetailsList,
  addHighlightsDetail,
  clearAddHighlightsDetail,
  patchHighlightsDetail,
  clearPatchHighlightsDetail,
  deleteHighlightsDetail,
  clearDeleteHighlightsDetail,
} from 'redux/highlights/actions';

import Button from 'components/elements/buttons/Button';
import CommonStanaloneInput
  from 'components/elements/inputs/CommonStanaloneInput';
import HighLightsDetailsInput
  from 'components/dashboard/appearance-content/HighLightsDetailsInput';

import './HighLightsDetails.css';


class HighLightsDetails extends Component {
  static propTypes = {
    patchUser: PropTypes.func.isRequired,
    fetchHighlightsDetailsList: PropTypes.func.isRequired,
    addHighlightsDetail: PropTypes.func.isRequired,
    clearAddHighlightsDetail: PropTypes.func.isRequired,
    patchHighlightsDetail: PropTypes.func.isRequired,
    clearPatchHighlightsDetail: PropTypes.func.isRequired,
    deleteHighlightsDetail: PropTypes.func.isRequired,
    clearDeleteHighlightsDetail: PropTypes.func.isRequired,
    me: PropTypes.object,
    patchUserError: PropTypes.object,
    highlightsDetailsList: PropTypes.arrayOf(PropTypes.shape),
    highlightsDetailsListError: PropTypes.object,
    addHighlightsDetailSuccess: PropTypes.object,
    addHighlightsDetailError: PropTypes.object,
    patchHighlightsDetailSuccess: PropTypes.object,
    patchHighlightsDetailError: PropTypes.object,
    deleteHighlightsDetailSuccess: PropTypes.object,
    deleteHighlightsDetailError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    patchUserError: null,
    highlightsDetailsList: null,
    highlightsDetailsListError: null,
    addHighlightsDetailSuccess: null,
    addHighlightsDetailError: null,
    patchHighlightsDetailSuccess: null,
    patchHighlightsDetailError: null,
    deleteHighlightsDetailSuccess: null,
    deleteHighlightsDetailError: null,
  };

  state = {
    showAdditionalDetail: true,
  };

  componentDidUpdate(prevProps) {
    // Add
    if (!prevProps.addHighlightsDetailSuccess && this.props.addHighlightsDetailSuccess) {
      this.setState({ showAdditionalDetail: false });
      this.props.fetchHighlightsDetailsList();
      this.props.clearAddHighlightsDetail();
    }

    // Patch
    if (!prevProps.patchHighlightsDetailSuccess && this.props.patchHighlightsDetailSuccess) {
      this.props.fetchHighlightsDetailsList();
      this.props.clearPatchHighlightsDetail();
    }

    // Delete
    if (!prevProps.deleteHighlightsDetailSuccess && this.props.deleteHighlightsDetailSuccess) {
      this.props.fetchHighlightsDetailsList();
      this.props.clearDeleteHighlightsDetail();
    }
  }

  componentWillUnmount() {
    this.props.clearAddHighlightsDetail();
    this.props.clearPatchHighlightsDetail();
    this.props.clearDeleteHighlightsDetail();
    if (this.props.highlightsDetailsList && this.props.highlightsDetailsList.length > 0) {
      this.setState({ showAdditionalDetail: false });
    }
  }

  render() {
    const {
      me,
      patchUser,
      patchUserError,
      highlightsDetailsList,
      highlightsDetailsListError,
      addHighlightsDetail,
      patchHighlightsDetail,
      deleteHighlightsDetail,
      addHighlightsDetailError,
      patchHighlightsDetailError,
      deleteHighlightsDetailError,
    } = this.props;

    return (
      <div className="highlights-details__component">
        <div className="highlights-title-field">
          <CommonStanaloneInput
            key="highlights-details-field-key-title"
            fieldName="highlights_title"
            label="Highlights Title"
            initValue={me.highlights_title}
            executedAction={patchUser}
            patchError={patchUserError}
          />
        </div>

        {highlightsDetailsList &&
          highlightsDetailsList.length > 0 &&
          <div className="highlights-details-fields">
            {highlightsDetailsList.map(item => (
              <div className="field-wrapper">
                <HighLightsDetailsInput
                  key={`highlights-details-field-key-${item.id}`}
                  label="Detail"
                  id={item.id}
                  initValue={item.content}
                  patchHighlightsDetail={patchHighlightsDetail}
                  deleteHighlightsDetail={deleteHighlightsDetail}
                  actionsErrors={addHighlightsDetailError ||
                    patchHighlightsDetailError || deleteHighlightsDetailError}
                />
              </div>
            ))}
          </div>
        }

        {!highlightsDetailsListError &&
          this.state.showAdditionalDetail &&
          <div className="highlights-additional-field">
            <HighLightsDetailsInput
              additional
              key="highlights-details-field-key-additional"
              label="New Detail"
              addHighlightsDetail={addHighlightsDetail}
              actionsErrors={addHighlightsDetailError}
            />
          </div>
        }

        <div className="buttons-block">
          <Button
            disabled={this.state.showAdditionalDetail}
            onClick={() => this.setState({ showAdditionalDetail: true })}
          >
            <div className="icon" />
            <div className="text">Add Additional Detail</div>
          </Button>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserError: state.settingsReducer.patchUserError,
    highlightsDetailsList: state.highlightsReducer.highlightsDetailsList,
    highlightsDetailsListError: state.highlightsReducer.highlightsDetailsListError,
    addHighlightsDetailSuccess: state.highlightsReducer.addHighlightsDetailSuccess,
    addHighlightsDetailError: state.highlightsReducer.addHighlightsDetailError,
    patchHighlightsDetailSuccess: state.highlightsReducer.patchHighlightsDetailSuccess,
    patchHighlightsDetailError: state.highlightsReducer.patchHighlightsDetailError,
    deleteHighlightsDetailSuccess: state.highlightsReducer.deleteHighlightsDetailSuccess,
    deleteHighlightsDetailError: state.highlightsReducer.deleteHighlightsDetailError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
    fetchHighlightsDetailsList,
    addHighlightsDetail,
    clearAddHighlightsDetail,
    patchHighlightsDetail,
    clearPatchHighlightsDetail,
    deleteHighlightsDetail,
    clearDeleteHighlightsDetail,
  },
)(HighLightsDetails);
